import React, { Component } from 'react';

import { HeaderPortal } from '../Header';
import InnerLayout from './inner_layout';
import IdleTimeout from '../../widgets/idle_timeout';
import WelcomeHandler from '../../wrapper/extracted_wrapper_ui';
import WelcomeHandlerMobile from '../../wrapper/extracted_wrapper_ui_mobile';
import MobileStripe from './mobile_stripe';
import HeaderNavMobile from '../HeaderNavMobile';
import FooterNav from '../FooterNav';
import HeaderNavDesktop from '../HeaderNavDesktop';
import promotion from '../../../../promotion_config';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showGTMNoScript: false,
        };
    }

    componentDidMount() {
        this.pageStateActions();
        if (window?.location?.host === promotion?.prodhost) {
            this.setState({ showGTMNoScript: true });
        }
    }

    async pageStateActions() {
        this.props.actions.configActions.getConfig();
        await this.props.actions.userActions.getPlayerData();
    }

    render() {
        const { showGTMNoScript } = this.state;
        return (
            <>
                {showGTMNoScript && (
                    <noscript>
                        <iframe
                            src='https://www.googletagmanager.com/ns.html?id=GTM-PTG4979'
                            height='0'
                            width='0'
                            style={{ display: 'none', visibility: 'hidden' }}
                            title='Google Tag Manager Body iFrame'></iframe>
                    </noscript>
                )}
                <IdleTimeout />
                <WelcomeHandler />
                <WelcomeHandlerMobile />
                <HeaderPortal />
                <HeaderNavDesktop />
                <HeaderNavMobile />
                <MobileStripe />
                <FooterNav />
                <InnerLayout {...this.props}>{this.props.children}</InnerLayout>
            </>
        );
    }
}

export default Layout;
